<template>
  <div>
    <nav class="breadcrumb" aria-label="breadcrumbs">
      <ul>
        <li><router-link to="/users">Users</router-link></li>
        <li><router-link v-bind:to="`/users/${this.$route.params.user_id}`">{{ this.$store.state.user.name || 'No name' }}</router-link></li>
        <li class="is-active"><a href="#" aria-current="page">Edit user name</a></li>
      </ul>
    </nav>

    <div class="columns">
      <div class="column is-6 is-offset-3" v-on:keyup.enter="submit">
        <div class="field">
          <label class="label">User name</label>
          <div class="control">
            <input
              name="name"
              type="text"
              placeholder="User name"
              v-model="fields.name"
              v-bind:class="{ 'input': true, 'is-danger': veeErrors.has('name') }"
              v-validate="'required'"
              data-vv-as="User name">
          </div>
          <span v-show="veeErrors.has('name')" class="help is-danger">{{ veeErrors.first('name') }}</span>
        </div>

        <div class="field is-grouped">
          <div class="control">
            <button v-bind:class="{ 'button': true, 'is-primary': true, 'is-loading': isLoading }" v-on:click="submit">Submit</button>
          </div>
          <div class="control">
            <router-link v-bind:to="`/users/${this.$route.params.user_id}`" class="button" exact>Cancel</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        fields: {
          name: ''
        },
        isLoading: false
      }
    },

    methods: {
      submit () {
        this.$validator.validateAll().then((passed) => {
          if (!passed) {
            return
          }

          this.isLoading = true

          this.$store.dispatch('updateUser', {
            userId: this.$route.params.user_id,
            params: this.fields
          })
            .then(() => {
              this.$router.push(`/users/${this.$route.params.user_id}`)
            })
            .catch(() => {
              // Add server errors into the existing ErrorBag object
              if (this.$store.state.error.response) {
                Object.keys(this.$store.state.error.response.data.error.validation_errors).forEach(key => {
                  this.veeErrors.add(key, this.$store.state.error.response.data.error.validation_errors[key][0])
                })
              }

              this.isLoading = false
            })
        })
      }
    },

    created () {
      this.$store.dispatch('getUser', {
        userId: this.$route.params.user_id
      })
        .then(() => {
          this.fields = {
            name: this.$store.state.user.name
          }
        })
    }
  }
</script>



// WEBPACK FOOTER //
// UserForm.vue?63cad48f